// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flights-XbixS";
var _3 = "flight-3KuEN";
var _4 = "flight_icon-3yYDb";
var _5 = "flight_count-ZJrKi";
var _6 = "flight_info-1ansk";
var _7 = "flight_direction-pLvEU";
var _8 = "flight_deleteButton-33C73";
var _9 = "card-20RPg";
var _a = "card__icon-3IJkf";
export { _1 as "__esModule", _2 as "flights", _3 as "flight", _4 as "flight_icon", _5 as "flight_count", _6 as "flight_info", _7 as "flight_direction", _8 as "flight_deleteButton", _9 as "card", _a as "card__icon" }
export default { "__esModule": _1, "flights": _2, "flight": _3, "flight_icon": _4, "flight_count": _5, "flight_info": _6, "flight_direction": _7, "flight_deleteButton": _8, "card": _9, "card__icon": _a }
